export default __webpack_public_path__ + "static/media/dashboard-investor-list-icon-light.b30476bc.svg";